import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getBranches } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class BranchDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      branch: [],
      formData: {
        name: ''
      },
      loading: false,
      isLoad: true
    }
  }
  componentDidMount() {
    this.getBranchInfo();
  }
  getBranchInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/branches/info/' + id, 'get', null);
      this.setState({ branch: response });
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        updatedData[key] = response[key] === undefined ? "" : response[key]
      })
      this.setState({ formData: updatedData, isLoad: false }, () => { });
    } catch (e) {
      this.setState({ isLoad: false });
    }
  }
  setBranches = async () => {
    const branches = await getBranches();
    localStorage.setItem('branches', JSON.stringify(branches));
  }
  handleChance = (e) => {
    const { id, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: value
      }
    }))
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const id = this.props.match.params.id;
    const { formData } = this.state;
    const branchFormData = new FormData();
    Object.keys(formData).forEach(key => {
      branchFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/branches/update/' + id, 'post', branchFormData);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const { formData, loading } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateBranchPermission = userPermissions.includes('update branch');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Şube Detayı"
              Breadcrumb={[
                { name: "Şubeler", navigate: "branches" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="card">
                <form onSubmit={this.handleSubmit}>
                  <div className="body">
                    <div className="row clearfix justify-content-center">
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <input
                            id="name"
                            className="form-control"
                            placeholder="Ad"
                            type="text"
                            value={formData.name || ''}
                            onChange={this.handleChance}
                          />
                        </div>

                      </div>
                    </div>

                  </div>
                  <div className="body">
                    <div className="row clearfix justify-content-center">
                      <div className="col-lg-6 col-md-12">
                        {loading ? (
                          <button className="btn btn-outline-primary btn-block" disabled={true}
                            style={{ textAlign: "-webkit-center" }}>
                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                              color="#268bd2"></ReactLoading>
                          </button>
                        ) :
                          <button disabled={!userHasUpdateBranchPermission} className="btn btn-outline-primary btn-block" type="submit">
                            Güncelle
                          </button>}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(BranchDetail)));
